import { CompanyTypeSlug } from './companies'

export const WORKFLOW_STATUS = {
  DRAFT: 'draft',
  CONTACTS_REQUESTED: 'contacts_requested',
  READY_TO_LAUNCH: 'ready_to_launch',
  ACTIVE: 'active',
  COMPLETE: 'complete',
  PAUSED: 'paused',
} as const

export type WorkflowStatus =
  (typeof WORKFLOW_STATUS)[keyof typeof WORKFLOW_STATUS]

export const WORKFLOW_STATUS_LABELS: Record<string, string> = {
  [WORKFLOW_STATUS.DRAFT]: 'Draft',
  [WORKFLOW_STATUS.CONTACTS_REQUESTED]: 'Contacts Requested',
  [WORKFLOW_STATUS.READY_TO_LAUNCH]: 'Ready to Launch',
  [WORKFLOW_STATUS.ACTIVE]: 'Active',
  [WORKFLOW_STATUS.COMPLETE]: 'Complete',
  [WORKFLOW_STATUS.PAUSED]: 'Paused',
}

export type Campaign = {
  id: number
  company_id: number
  color: string

  name: string
  description: string
  type: {
    id: number
    name: string
    slug: CompanyTypeSlug
  } | null
  product?: {
    id: number
    name: string
  }

  created: string
  modified: string
  days_since_last_update: string

  days_since_sent: number | null
  days_since_reply: number | null

  contact_company_count: number
  door_count: number

  deal_count: number
  deal_perc: number
  deal_perc_won: number

  contact_count: number
  companies_with_contacts: number
  companies_with_contacts_perc: number
  taro: number
  taro_closed: number
  taro_est_meals_day: number

  workflow_status: WorkflowStatus
  launch_date: string | null
  owner_id: number | null
  owner_name: string | null

  bison_campaign_id: number | null
  interested_rate: number | null
  reply_count: number | null
  unread_reply_count: number | null
  action_needed_count: number | null
  bounce_count: number | null
}
